import { z } from "zod";

export const UpdateDocumentCounterpartyBodySchema = z.object({
    counterpartyId: z.string().uuid().nullable(),
});
